import { smallStore } from 'stores/smallStore/smallStore'
import { SprayRecordsModal } from '../components/SprayRecordsModal/SprayRecordsModal'

export const useSprayRecords = () => {
  const showSprayRecordsModal = smallStore.useSelector((s) => s.showSprayRecordsModal)

  return {
    showSprayRecords: () => smallStore.setState((s) => ({ ...s, showSprayRecordsModal: true })),
    hideSprayRecords: () => smallStore.setState((s) => ({ ...s, showSprayRecordsModal: false })),
    isOpenedSprayRecordsModal: showSprayRecordsModal,
    SprayRecordsModal,
  }
}
